import logo1 from "./Images/logo1.png";

function WebLogo() {
  return (
    <div className="weblogo">
      <img src={logo1} className="weblogo" alt="logo" />
    </div>
  );
}
export default WebLogo;
